import { formatDistanceToNow } from 'date-fns';
import { shortTimestamp } from 'shared/helpers/timeHelper';

export const shortTimestampFromDate = ({ time, withAgo = false }) => {
  const relativeTime = formatDistanceToNow(new Date(time * 1000), {
    addSuffix: true,
  });

  return shortTimestamp(relativeTime, withAgo);
};
